export class District{
    id : number;
    districtCode : string;
    districtName : string;
    provinceId : number;
    provinceName : string; 
}